import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import CryptoJS from "crypto-js";
import { useApi } from "../../../hooks/useApi";
import ConfirmBtn from "../../Button/ConfirmBtn";
import LoginInput from "../../Input/LoginInput";
import LoginErrorMessage, { ErrorMessage } from "../../Login/LoginErrorMessage";
import DefaultModalLayout from "../../Modal/DefaultModalLayout";
import { useSetRecoilState } from "recoil";
import { userDataType } from "../../../pages/Login";
import useMy from "../../../hooks/useMy";

interface PwResettingModalProps {
  closeEvent: () => void;
  confirmEvent?: () => void;
  email?: string;
  originPw?: string;
}

export default function PwResettingModal({
  closeEvent,
  confirmEvent,
  email,
  originPw,
}: PwResettingModalProps) {
  console.log(email);

  const { email: myEmail } = useMy();
  console.log(myEmail);

  const { pathname } = useLocation();

  console.log(originPw);

  const [newPw, setNewPw] = useState("");
  const [confirmNewPw, setConfirmNewPw] = useState("");
  const [isWrong, setIsWrong] = useState(false);
  const [btnClick, setBtnClick] = useState(false);
  const [executeLogin, setExecuteLogin] = useState(false);
  const [user, setUser] = useState(null);

  const setUserData = useSetRecoilState(userDataType);

  const { response } = useApi({
    url: btnClick ? "login/changePW/change" : undefined,
    method: "post",
    data: {
      password: CryptoJS.enc.Hex.stringify(CryptoJS.SHA1(newPw)),
      originPW: CryptoJS.enc.Hex.stringify(CryptoJS.SHA1(originPw!)),
      email: email ?? myEmail,
    },
  });

  const { response: loginResponse } = useApi({
    url: executeLogin ? "login" : undefined,
    method: "post",
    data: {
      email: email ?? myEmail,
      password: CryptoJS.enc.Hex.stringify(CryptoJS.SHA1(newPw)),
    },
  });

  console.log(response);

  useEffect(() => {
    if (newPw?.length > 0 && confirmNewPw?.length > 0) {
      if (newPw !== confirmNewPw) {
        setIsWrong(true);
        setBtnClick(false);
      } else {
        setIsWrong(false);
      }
    }
  }, [newPw, confirmNewPw]);

  useEffect(() => {
    if (response?.status === 200 || response?.status === 201) {
      setExecuteLogin(true);
    }
  }, [response]);

  useEffect(() => {
    if (loginResponse?.status === 200 || loginResponse?.status === 201) {
      setUser(loginResponse?.data);
      setUserData(loginResponse?.data);
      sessionStorage.setItem("sid", loginResponse?.data?.sid);
      sessionStorage.setItem("email", loginResponse?.data?.email);
      sessionStorage.setItem("grade", loginResponse?.data?.grade);
      sessionStorage.setItem("name", loginResponse?.data?.name);

      if (confirmEvent) {
        confirmEvent();
      }
    }
  }, [loginResponse]);

  return (
    <DefaultModalLayout
      isMediumModal={true}
      modalTitle="비밀번호 설정"
      closeEvent={() => closeEvent()}
      confirmEvent={() => setBtnClick(true)}
      leftBottomBtn={<></>}
      confirmDisabled={
        newPw === "" || confirmNewPw === "" || newPw !== confirmNewPw
      }
      cancelBtn={
        <ConfirmBtn
          btnText="취소"
          btnColor="white"
          btnClickEvent={() => closeEvent()}
        />
      }
    >
      <LoginInputModalContainer>
        {/* 새 비밀번호 */}
        <LoginInput
          label="새 비밀번호"
          value={newPw}
          onChangeEvent={(e) => setNewPw(e.target.value)}
          isPassword={true}
        />

        {/* 새 비밀번호 확인 */}
        <LoginInput
          label="새 비밀번호 확인"
          value={confirmNewPw}
          onChangeEvent={(e) => setConfirmNewPw(e.target.value)}
          isPassword={true}
          hasError={isWrong}
        />

        {isWrong && <LoginErrorMessage msg={"비밀번호가 일치하지 않습니다."} />}
      </LoginInputModalContainer>

      <>
        {pathname === "/login" && (
          <InitDesc>
            <span className="material-icons-outlined">info</span>
            비밀번호 설정을 완료해야 링키드 관리자 페이지 접근 권한이
            부여됩니다.
          </InitDesc>
        )}
      </>

      <>{user && <Navigate to="/"></Navigate>}</>
    </DefaultModalLayout>
  );
}

export const LoginInputModalContainer = styled.div`
  max-width: 380px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const InitDesc = styled(ErrorMessage)`
  margin-top: 10px;
  color: #858c97;
`;
